module.exports = __webpack_public_path__ + "static/img/img_ab_zz_bg.6e872feb.png";